var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3500 2000",
    style: {
      enableBackground: "new 0 0 3500 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "top"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 3500,
    height: 2000
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120541915397575798190000005894964115331127188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120541915397575798190000005894964115331127188_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.344,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -608.3419 511.6955)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.325,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -502.0282 768.3662)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: 755.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -426.852 586.8734)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: 1118.516,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -683.5188 693.1884)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "597.505,742.695 494.992,640.183  392.479,742.695 247.505,742.695 247.505,887.67 144.992,990.183 247.505,1092.695 247.505,1237.67 392.479,1237.67  494.992,1340.183 597.505,1237.67 742.479,1237.67 742.479,1092.695 844.992,990.183 742.479,887.67 742.479,742.695  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.344,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 91.6571 221.7477)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.325,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 197.9705 478.4129)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: 128.567,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 16.4808 403.2377)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: -234.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 273.1472 296.9231)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "597.505,247.721 494.992,350.234  392.479,247.721 247.505,247.721 247.505,102.747 144.992,0.234 247.505,-102.279 247.505,-247.253 392.479,-247.253  494.992,-349.766 597.505,-247.253 742.479,-247.253 742.479,-102.279 844.992,0.234 742.479,102.747 742.479,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755.318,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -113.3681 716.7206)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.142,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.142,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1118.3,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.0519 973.3914)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.809,
    y: 260.56,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 68.1232 791.8985)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.809,
    y: 623.541,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -188.5436 898.2136)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1092.479,247.721 989.967,145.208  887.454,247.721 742.479,247.721 742.479,392.695 639.967,495.208 742.479,597.721 742.479,742.695 887.454,742.695  989.967,845.208 1092.479,742.695 1237.454,742.695 1237.454,597.721 1339.967,495.208 1237.454,392.695 1237.454,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.193,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.193,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.351,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -297.0027 273.3893)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.473,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.473,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -234.631,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -403.3161 16.7214)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.14,
    y: 260.56,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -221.8264 91.8978)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.14,
    y: 623.541,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -478.4928 198.2123)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "-102.495,247.721 0.017,145.208  102.53,247.721 247.505,247.721 247.505,392.695 350.017,495.208 247.505,597.721 247.505,742.695 102.53,742.695  0.017,845.208 -102.495,742.695 -247.47,742.695 -247.47,597.721 -349.983,495.208 -247.47,392.695 -247.47,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "597.504,537.67 639.967,495.208  597.504,452.746 597.504,392.696 537.454,392.696 494.992,350.234 452.53,392.696 392.479,392.696 392.479,452.746  350.017,495.208 392.479,537.67 392.479,597.721 452.53,597.721 494.992,640.183 537.454,597.721 597.504,597.721  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.504,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 313.717,
    transform: "matrix(-1 -4.482515e-11 4.482515e-11 -1 705.9807 706.4133)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.504,
    y: 597.721,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 597.721,
    transform: "matrix(-1 4.494570e-11 -4.494570e-11 -1 705.9807 1274.42)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1092.479,42.711 1134.941,0.248  1092.479,-42.214 1092.479,-102.264 1032.429,-102.264 989.967,-144.726 947.504,-102.264 887.454,-102.264 887.454,-42.214  844.992,0.248 887.454,42.711 887.454,102.761 947.504,102.761 989.967,145.223 1032.429,102.761 1092.479,102.761  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: -181.242,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: -181.242,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 1695.9298 -283.5065)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: 102.761,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 102.761,
    transform: "matrix(-1 4.495148e-11 -4.495148e-11 -1 1695.9298 284.5003)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "102.512,42.711 144.975,0.248  102.512,-42.214 102.512,-102.264 42.462,-102.264 0,-144.726 -42.462,-102.264 -102.512,-102.264 -102.512,-42.214  -144.975,0.248 -102.512,42.711 -102.512,102.761 -42.462,102.761 0,145.223 42.462,102.761 102.512,102.761  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: -181.242,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: -181.242,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 -284.0032 -283.5065)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: 102.761,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: 102.761,
    transform: "matrix(-1 4.495148e-11 -4.495148e-11 -1 -284.0032 284.5003)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.344,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1308.3408 801.644)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.168,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.325,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1202.0298 1058.3174)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: 1745.484,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1126.8524 876.8234)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.835,
    y: 2108.465,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1383.5193 983.1384)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "597.505,1732.645 494.992,1630.132  392.479,1732.645 247.505,1732.645 247.505,1877.619 144.992,1980.132 247.505,2082.645 247.505,2227.619 392.479,2227.619  494.992,2330.132 597.505,2227.619 742.479,2227.619 742.479,2082.645 844.992,1980.132 742.479,1877.619 742.479,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755.318,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -813.3688 1006.6735)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.142,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.142,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1118.3,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -707.0528 1263.3334)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.809,
    y: 1613.491,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -888.5436 1188.1605)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.809,
    y: 1250.51,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -631.8772 1081.8459)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1092.479,1732.645 989.967,1835.158  887.454,1732.645 742.479,1732.645 742.479,1587.671 639.967,1485.158 742.479,1382.645 742.479,1237.671 887.454,1237.671  989.967,1135.158 1092.479,1237.671 1237.454,1237.671 1237.454,1382.645 1339.967,1485.158 1237.454,1587.671  1237.454,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.193,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.193,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.351,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -997.0016 563.3368)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.473,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.473,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -234.631,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1103.3206 306.6739)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.14,
    y: 1613.491,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1178.4944 488.1633)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.14,
    y: 1250.51,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -921.8276 381.8483)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "-102.495,1732.645 0.017,1835.158  102.53,1732.645 247.505,1732.645 247.505,1587.671 350.017,1485.158 247.505,1382.645 247.505,1237.671 102.53,1237.671  0.017,1135.158 -102.495,1237.671 -247.47,1237.671 -247.47,1382.645 -349.983,1485.158 -247.47,1587.671 -247.47,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "597.504,1442.696 639.967,1485.158  597.504,1527.62 597.504,1587.67 537.454,1587.67 494.992,1630.132 452.53,1587.67 392.479,1587.67 392.479,1527.62  350.017,1485.158 392.479,1442.696 392.479,1382.645 452.53,1382.645 494.992,1340.183 537.454,1382.645 597.504,1382.645  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.504,
    y: 1587.67,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 1587.67,
    transform: "matrix(-1 4.494570e-11 -4.494570e-11 -1 705.9807 3254.3186)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 597.504,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.501,
    y: 1303.667,
    transform: "matrix(-1 -4.483093e-11 4.483093e-11 -1 705.9807 2686.3118)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1092.479,1937.655 1134.941,1980.118  1092.479,2022.58 1092.479,2082.63 1032.429,2082.63 989.967,2125.092 947.504,2082.63 887.454,2082.63 887.454,2022.58  844.992,1980.118 887.454,1937.655 887.454,1877.605 947.504,1877.605 989.967,1835.143 1032.429,1877.605 1092.479,1877.605  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: 2082.63,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 2082.63,
    transform: "matrix(-1 4.494570e-11 -4.494570e-11 -1 1695.9298 4244.2383)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: 1798.627,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 1798.627,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 1695.9298 3676.2317)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "102.512,1937.655 144.975,1980.118  102.512,2022.58 102.512,2082.63 42.462,2082.63 0,2125.092 -42.462,2082.63 -102.512,2082.63 -102.512,2022.58  -144.975,1980.118 -102.512,1937.655 -102.512,1877.605 -42.462,1877.605 0,1835.143 42.462,1877.605 102.512,1877.605  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: 2082.63,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: 2082.63,
    transform: "matrix(-1 4.494570e-11 -4.494570e-11 -1 -284.0032 4244.2383)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: 1798.627,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: 1798.627,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 -284.0032 3676.2317)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1092.479,1032.645 1134.941,990.183  1092.479,947.721 1092.479,887.67 1032.429,887.67 989.967,845.208 947.504,887.67 887.454,887.67 887.454,947.721  844.992,990.183 887.454,1032.645 887.454,1092.695 947.504,1092.695 989.967,1135.158 1032.429,1092.695 1092.479,1092.695  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 808.692,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 1695.9298 1696.3625)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1092.479,
    y: 1092.695,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.476,
    y: 1092.695,
    transform: "matrix(-1 4.481914e-11 -4.481914e-11 -1 1695.9298 2264.3694)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "102.512,1032.645 144.975,990.183  102.512,947.721 102.512,887.67 42.462,887.67 0,845.208 -42.462,887.67 -102.512,887.67 -102.512,947.721 -144.975,990.183  -102.512,1032.645 -102.512,1092.695 -42.462,1092.695 0,1135.158 42.462,1092.695 102.512,1092.695  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: 808.692,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 -284.0032 1696.3625)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.512,
    y: 1092.695,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: -181.491,
    y: 1092.695,
    transform: "matrix(-1 4.481914e-11 -4.481914e-11 -1 -284.0032 2264.3694)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1613.274,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -212.0777 1468.3654)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250.293,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -318.3936 1211.6923)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: 755.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -136.9028 1286.871)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: 1118.516,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -393.5692 1393.1855)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1382.428,742.695 1484.941,640.183  1587.454,742.695 1732.428,742.695 1732.428,887.67 1834.941,990.183 1732.428,1092.695 1732.428,1237.67 1587.454,1237.67  1484.941,1340.183 1382.428,1237.67 1237.454,1237.67 1237.454,1092.695 1134.941,990.183 1237.454,887.67 1237.454,742.695  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1613.274,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 487.9196 1178.4124)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250.293,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 381.6086 921.7495)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: 128.567,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 306.4312 1103.2389)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: -234.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 563.098 996.9238)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1382.428,247.721 1484.941,350.234  1587.454,247.721 1732.428,247.721 1732.428,102.747 1834.941,0.234 1732.428,-102.279 1732.428,-247.253 1587.454,-247.253  1484.941,-349.766 1382.428,-247.253 1237.454,-247.253 1237.454,-102.279 1134.941,0.234 1237.454,102.747 1237.454,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.425,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1798.425,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.268,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 176.5804 1416.7196)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2055.092,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2055.092,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2108.249,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 282.8993 1673.3929)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1926.758,
    y: 260.56,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 358.0732 1491.8989)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1926.758,
    y: 623.541,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 101.4063 1598.2139)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2082.428,247.721 1979.916,145.208  1877.403,247.721 1732.428,247.721 1732.428,392.695 1629.916,495.208 1732.428,597.721 1732.428,742.695 1877.403,742.695  1979.916,845.208 2082.428,742.695 2227.403,742.695 2227.403,597.721 2329.916,495.208 2227.403,392.695 2227.403,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1382.429,537.67 1339.967,495.208  1382.429,452.746 1382.429,392.696 1442.479,392.696 1484.941,350.234 1527.403,392.696 1587.454,392.696 1587.454,452.746  1629.916,495.208 1587.454,537.67 1587.454,597.721 1527.403,597.721 1484.941,640.183 1442.479,597.721 1382.429,597.721  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 313.717,
    transform: "matrix(-1 -4.482515e-11 4.482515e-11 -1 2685.8792 706.4133)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1587.454,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 597.721,
    transform: "matrix(-1 -4.493440e-11 4.493440e-11 -1 2685.8792 1274.42)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1587.454,
    y: 597.721,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1877.421,42.711 1834.958,0.248  1877.421,-42.214 1877.421,-102.264 1937.471,-102.264 1979.933,-144.726 2022.395,-102.264 2082.446,-102.264  2082.446,-42.214 2124.907,0.248 2082.446,42.711 2082.446,102.761 2022.395,102.761 1979.933,145.223 1937.471,102.761  1877.421,102.761  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: -181.242,
    transform: "matrix(-1 -4.495172e-11 4.495172e-11 -1 3675.863 -283.5065)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: -181.242,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: 102.761,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 3675.863 284.5003)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: 102.761,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.117,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1613.274,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -912.0784 1758.3157)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250.293,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1018.3917 1501.64)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: 1745.484,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -836.902 1576.8198)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1431.784,
    y: 2108.465,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1093.5685 1683.1344)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1382.428,1732.645 1484.941,1630.132  1587.454,1732.645 1732.428,1732.645 1732.428,1877.619 1834.941,1980.132 1732.428,2082.645 1732.428,2227.619  1587.454,2227.619 1484.941,2330.132 1382.428,2227.619 1237.454,2227.619 1237.454,2082.645 1134.941,1980.132  1237.454,1877.619 1237.454,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.425,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1798.425,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.268,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -523.4185 1706.6741)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2055.092,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2055.092,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2108.249,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -417.1051 1963.3314)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1926.758,
    y: 1613.491,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -598.5948 1888.1598)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1926.758,
    y: 1250.51,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -341.9284 1781.8452)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2082.428,1732.645 1979.916,1835.158  1877.403,1732.645 1732.428,1732.645 1732.428,1587.671 1629.916,1485.158 1732.428,1382.645 1732.428,1237.671  1877.403,1237.671 1979.916,1135.158 2082.428,1237.671 2227.403,1237.671 2227.403,1382.645 2329.916,1485.158  2227.403,1587.671 2227.403,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1382.429,1442.696 1339.967,1485.158  1382.429,1527.62 1382.429,1587.67 1442.479,1587.67 1484.941,1630.132 1527.403,1587.67 1587.454,1587.67 1587.454,1527.62  1629.916,1485.158 1587.454,1442.696 1587.454,1382.645 1527.403,1382.645 1484.941,1340.183 1442.479,1382.645  1382.429,1382.645  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 1587.67,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 2685.8792 3254.3186)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1587.454,
    y: 1587.67,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1303.45,
    y: 1303.667,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 2685.8792 2686.3118)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1587.454,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3045.075,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3045.075,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3098.233,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 572.8583 2373.4158)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 570.384,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2735.251,
    y: 442.051,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 466.537 2116.74)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2916.742,
    y: 260.56,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 648.0302 2191.9199)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2916.742,
    y: 623.541,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 391.3638 2298.2344)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2867.387,247.721 2969.9,145.208  3072.412,247.721 3217.387,247.721 3217.387,392.695 3319.9,495.208 3217.387,597.721 3217.387,742.695 3072.412,742.695  2969.9,845.208 2867.387,742.695 2722.412,742.695 2722.412,597.721 2619.9,495.208 2722.412,392.695 2722.412,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2867.387,42.711 2824.925,0.248  2867.387,-42.214 2867.387,-102.264 2927.438,-102.264 2969.9,-144.726 3012.362,-102.264 3072.412,-102.264 3072.412,-42.214  3114.874,0.248 3072.412,42.711 3072.412,102.761 3012.362,102.761 2969.9,145.223 2927.438,102.761 2867.387,102.761  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: -181.242,
    transform: "matrix(-1 -4.495172e-11 4.495172e-11 -1 5655.7959 -283.5065)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: -181.242,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 102.761,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 5655.7959 284.5003)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: 102.761,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3045.075,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3045.075,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3098.233,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -127.1459 2663.3582)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 1560.334,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2735.251,
    y: 1432,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -233.4569 2406.7031)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2916.742,
    y: 1613.491,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -308.6343 2588.189)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2916.742,
    y: 1250.51,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.9675 2481.874)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2867.387,1732.645 2969.9,1835.158  3072.412,1732.645 3217.387,1732.645 3217.387,1587.671 3319.9,1485.158 3217.387,1382.645 3217.387,1237.671  3072.412,1237.671 2969.9,1135.158 2867.387,1237.671 2722.412,1237.671 2722.412,1382.645 2619.9,1485.158 2722.412,1587.671  2722.412,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2867.387,1937.655 2824.925,1980.118  2867.387,2022.58 2867.387,2082.63 2927.438,2082.63 2969.9,2125.092 3012.362,2082.63 3072.412,2082.63 3072.412,2022.58  3114.874,1980.118 3072.412,1937.655 3072.412,1877.605 3012.362,1877.605 2969.9,1835.143 2927.438,1877.605  2867.387,1877.605  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 2082.63,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 5655.7959 4244.2383)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: 2082.63,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 1798.627,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 5655.7959 3676.2317)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: 1798.627,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2867.387,1032.645 2824.925,990.183  2867.387,947.721 2867.387,887.67 2927.438,887.67 2969.9,845.208 3012.362,887.67 3072.412,887.67 3072.412,947.721  3114.874,990.183 3072.412,1032.645 3072.412,1092.695 3012.362,1092.695 2969.9,1135.158 2927.438,1092.695 2867.387,1092.695  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 808.692,
    transform: "matrix(-1 -4.495749e-11 4.495749e-11 -1 5655.7959 1696.3625)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2788.409,
    y: 1092.695,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 5655.7959 2264.3694)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3072.412,
    y: 1092.695,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2240.277,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.4346 1911.7178)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2603.258,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 77.8843 2168.3938)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: 755.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 153.0582 1986.8986)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: 1118.516,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -103.6087 2093.2136)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2577.438,742.695 2474.925,640.183  2372.412,742.695 2227.438,742.695 2227.438,887.67 2124.925,990.183 2227.438,1092.695 2227.438,1237.67 2372.412,1237.67  2474.925,1340.183 2577.438,1237.67 2722.412,1237.67 2722.412,1092.695 2824.925,990.183 2722.412,887.67 2722.412,742.695  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2240.277,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 671.5679 1621.7736)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2603.258,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 777.876 1878.4335)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: 128.567,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 596.3886 1803.2606)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: -234.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 853.0551 1696.946)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2577.438,247.721 2474.925,350.234  2372.412,247.721 2227.438,247.721 2227.438,102.747 2124.925,0.234 2227.438,-102.279 2227.438,-247.253 2372.412,-247.253  2474.925,-349.766 2577.438,-247.253 2722.412,-247.253 2722.412,-102.279 2824.925,0.234 2722.412,102.747 2722.412,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2577.438,537.67 2619.9,495.208  2577.438,452.746 2577.438,392.696 2517.387,392.696 2474.925,350.234 2432.463,392.696 2372.413,392.696 2372.413,452.746  2329.95,495.208 2372.413,537.67 2372.413,597.721 2432.463,597.721 2474.925,640.183 2517.387,597.721 2577.438,597.721  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2577.438,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 313.717,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 4665.8467 706.4133)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2577.438,
    y: 597.721,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 597.721,
    transform: "matrix(-1 4.495725e-11 -4.495725e-11 -1 4665.8467 1274.42)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2240.277,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -728.4336 2201.6663)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2550.101,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2603.258,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -622.1173 2458.345)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: 1745.484,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -546.9423 2276.8486)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2421.768,
    y: 2108.465,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -803.6091 2383.1636)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2577.438,1732.645 2474.925,1630.132  2372.412,1732.645 2227.438,1732.645 2227.438,1877.619 2124.925,1980.132 2227.438,2082.645 2227.438,2227.619  2372.412,2227.619 2474.925,2330.132 2577.438,2227.619 2722.412,2227.619 2722.412,2082.645 2824.925,1980.132  2722.412,1877.619 2722.412,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "2577.438,1442.696 2619.9,1485.158  2577.438,1527.62 2577.438,1587.67 2517.387,1587.67 2474.925,1630.132 2432.463,1587.67 2372.413,1587.67 2372.413,1527.62  2329.95,1485.158 2372.413,1442.696 2372.413,1382.645 2432.463,1382.645 2474.925,1340.183 2517.387,1382.645  2577.438,1382.645  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2577.438,
    y: 1587.67,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 1587.67,
    transform: "matrix(-1 4.494570e-11 -4.494570e-11 -1 4665.8467 3254.3186)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2577.438,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2293.434,
    y: 1303.667,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 4665.8467 2686.3118)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3593.208,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 367.8331 2868.3914)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 1065.359,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3230.226,
    y: 937.025,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 261.5118 2611.7129)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: 755.535,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 443.005 2686.8938)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: 1118.516,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 186.3386 2793.2085)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "3362.362,742.695 3464.874,640.183  3567.387,742.695 3712.362,742.695 3712.362,887.67 3814.874,990.183 3712.362,1092.695 3712.362,1237.67 3567.387,1237.67  3464.874,1340.183 3362.362,1237.67 3217.387,1237.67 3217.387,1092.695 3114.874,990.183 3217.387,887.67 3217.387,742.695  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3593.208,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1067.8268 2578.4348)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: -181.257,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 75.41,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3230.226,
    y: -52.923,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 961.5211 2321.7771)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: 128.567,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 886.3413 2503.2642)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: -234.414,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 1143.0082 2396.9492)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "3362.362,247.721 3464.874,350.234  3567.387,247.721 3712.362,247.721 3712.362,102.747 3814.874,0.234 3712.362,-102.279 3712.362,-247.253 3567.387,-247.253  3464.874,-349.766 3362.362,-247.253 3217.387,-247.253 3217.387,-102.279 3114.874,0.234 3217.387,102.747 3217.387,247.721  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "3362.362,537.67 3319.9,495.208  3362.362,452.746 3362.362,392.696 3422.412,392.696 3464.874,350.234 3507.336,392.696 3567.387,392.696 3567.387,452.746  3609.849,495.208 3567.387,537.67 3567.387,597.721 3507.336,597.721 3464.874,640.183 3422.412,597.721 3362.362,597.721  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 313.717,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 6645.7451 706.4133)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3567.387,
    y: 313.717,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 597.721,
    transform: "matrix(-1 -4.495749e-11 4.495749e-11 -1 6645.7451 1274.42)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3567.387,
    y: 597.721,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3540.05,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3593.208,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -332.1676 3158.3416)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 2055.308,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 1798.641,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3230.226,
    y: 1926.974,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -438.4862 2901.6606)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: 1745.484,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -256.9942 2976.8428)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3411.717,
    y: 2108.465,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -513.6606 3083.1572)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 106.315,
    height: 106.315
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "3362.362,1732.645 3464.874,1630.132  3567.387,1732.645 3712.362,1732.645 3712.362,1877.619 3814.874,1980.132 3712.362,2082.645 3712.362,2227.619  3567.387,2227.619 3464.874,2330.132 3362.362,2227.619 3217.387,2227.619 3217.387,2082.645 3114.874,1980.132  3217.387,1877.619 3217.387,1732.645  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "3362.362,1442.696 3319.9,1485.158  3362.362,1527.62 3362.362,1587.67 3422.412,1587.67 3464.874,1630.132 3507.336,1587.67 3567.387,1587.67 3567.387,1527.62  3609.849,1485.158 3567.387,1442.696 3567.387,1382.645 3507.336,1382.645 3464.874,1340.183 3422.412,1382.645  3362.362,1382.645  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 1587.67,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 6645.7451 3254.3186)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3567.387,
    y: 1587.67,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3283.384,
    y: 1303.667,
    transform: "matrix(-1 -4.495749e-11 4.495749e-11 -1 6645.7451 2686.3118)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3567.387,
    y: 1303.667,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1877.421,1937.655 1834.958,1980.118  1877.421,2022.58 1877.421,2082.63 1937.471,2082.63 1979.933,2125.092 2022.395,2082.63 2082.446,2082.63 2082.446,2022.58  2124.907,1980.118 2082.446,1937.655 2082.446,1877.605 2022.395,1877.605 1979.933,1835.143 1937.471,1877.605  1877.421,1877.605  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: 2082.63,
    transform: "matrix(-1 -4.481938e-11 4.481938e-11 -1 3675.863 4244.2383)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: 2082.63,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: 1798.627,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 3675.863 3676.2317)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: 1798.627,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "1877.421,1032.645 1834.958,990.183  1877.421,947.721 1877.421,887.67 1937.471,887.67 1979.933,845.208 2022.395,887.67 2082.446,887.67 2082.446,947.721  2124.907,990.183 2082.446,1032.645 2082.446,1092.695 2022.395,1092.695 1979.933,1135.158 1937.471,1092.695  1877.421,1092.695  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: 808.692,
    transform: "matrix(-1 -4.495749e-11 4.495749e-11 -1 3675.863 1696.3625)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: 808.692,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1798.442,
    y: 1092.695,
    transform: "matrix(-1 -4.494595e-11 4.494595e-11 -1 3675.863 2264.3694)",
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.446,
    y: 1092.695,
    style: {
      fill: "none",
      stroke: "#E6E6E6",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    width: 78.978,
    height: 78.978
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5ef40b0e9673cfe95acf78803f0270fa.svg";
export { ForwardRef as ReactComponent };